import {API_ROOT_URL} from 'envs/_current/config'
import {createAsyncAction} from 'modules/asyncCache'
import {normalize, schema} from 'normalizr'
import {baseFieldTypes} from './base/baseFieldTypes'
import {channelSchema, feedSchema, groupMemberSchema, groupSchema, organizationSchema, userSchema,} from './schema'
import {commentSchema} from './schema/commentSchema'
import {eventSchema} from './schema/event'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'


const auth_organization_schema = new schema.Entity(
    'organizations',
    {
        auth_user: userSchema,
    },
    {
        idAttribute: 'idname',
    }
)

const auth_organization_transform = (response, {query}) => {
    const {entities, result} = normalize(
        response.data,
        auth_organization_schema
    )
    if (Number(response?.status) !== 200) {
        return {
            error: true,
            errorMessages: response?.data,
        }
    } else {
        return {
            response,
            entities,
            result,
        }
    }
}

const fields = [
    'idname', // unique ~ username
    'user_id', // auto fill by login user
    'owner_id', // auto fill by login user
    'owner_type', // auto fill by login user
    'org_type', // 100: company
    'title', // Ten cong ty
    'description', // mo ta cong ty
    'avatar', // avatar
    'thumbnail', // tu gen ra boi avatar (kich thuoc nho hon)
    'cover_photo', // banner
    'status', // auto fill = 1
    'certified', // auto fill = 0
    'privacy', // 1: public, 2: private
    'public', // 1: search allow, 0: no searchable -> Kristo control
    'active', // 1: active (default), 0: inactive -> user control,
    'categories',
    'about', // rich text
]

const organization_FieldTypes = {
    user_id: baseFieldTypes.auto,
    owner_id: baseFieldTypes.auto,
    avatar: baseFieldTypes.image,
    cover_photo: baseFieldTypes.image,
    thumbnail: baseFieldTypes.auto,
    about: baseFieldTypes.string,
    // status: baseFieldTypes.status,
    // active: baseFieldTypes.active,
    // certified: baseFieldTypes.certified,
    // privacy: baseFieldTypes.privacy,
    // public: baseFieldTypes.public
}

const followSchema = new schema.Union(
    {
        organization: organizationSchema,
        group: groupSchema,
        channel: channelSchema,
        user: userSchema,
    },
    '_type'
)

// Route::post('organizations/add', 'OrganizationController@store');
export const organization_Create_Api = {
    backend: `Route::post('organizations/add', 'OrganizationController@store')`,
    root: API_ROOT_URL,
    path: '/organizations/add',
    method: 'POST',
    fields,
    schema: organizationSchema,
    fieldTypes: organization_FieldTypes,
    // schema: auth_organization_schema,
    transform: auth_organization_transform,
}

// Route::post('organizations/{id}/edit', 'OrganizationController@update');
export const organization_Edit_Api = {
    backend: `Route::post(''organizations/{id}/edit'', 'OrganizationController@update')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/edit',
    method: 'POST',
    fields,
    schema: organizationSchema,
    fieldTypes: organization_FieldTypes,
    // schema: auth_organization_schema,
    transform: auth_organization_transform,
}
// Route::post('organizations/{id}/delete', 'OrganizationController@deletePollQuestion');
export const organization_Delete_Api = {
    backend: `Route::post(''organizations/{id}/delete'', 'OrganizationController@deletePollQuestion')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/delete',
    method: 'POST',
    fields,
    schema: organizationSchema,
    fieldTypes: organization_FieldTypes,
    // schema: auth_organization_schema,
    transform: auth_organization_transform,
}

// Route::get('organizations/{id}/features', 'OrganizationFeatureController@getList');
export const organization_getFeatures_Api = {
    backend: `Route::get('organizations/:id/features', 'OrganizationFeatureController@getList')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/features',
    method: 'GET',
    transform: createTransform(null, 'data.data'),
}

// Route::post('organizations/{id}/features/{feature_key}/toggle', 'OrganizationFeatureController@toggle');
export const organization_toggleFeature_Api = {
    backend: `Route::post('organizations/:id/features/:feature_key/toggle', 'OrganizationFeatureController@toggle')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/features/:feature_key/toggle',
    method: 'POST',
    schema: organizationSchema,
    fieldTypes: organization_FieldTypes,
    transform: createTransform(organizationSchema, 'data'),
}

// Route::post('organizations/{id}/features/{feature_key}/request-verification', 'OrganizationFeatureController@requestVerification');
// Thay ContactAdministratorModal thụ động (chỉ hiện email/sđt) - owner gửi request THẬT kèm ghi
// chú liên hệ, backend ghi nhận trên organization_module_settings để nền tảng theo dõi/liên hệ lại.
export const organization_requestFeatureVerification_Api = {
    backend: `Route::post('organizations/:id/features/:feature_key/request-verification', 'OrganizationFeatureController@requestVerification')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/features/:feature_key/request-verification',
    method: 'POST',
    transform: createTransform(null, 'data'),
}

// Route::post('organizations/{id}/features/{feature_key}/override', 'OrganizationFeatureController@overridePlatformStatus');
// SYSTEM ADMIN ONLY - override cưỡng chế bật/tắt 1 module cho 1 org, luôn thắng lựa chọn owner.
export const organization_overrideFeature_Api = {
    backend: `Route::post('organizations/:id/features/:feature_key/override', 'OrganizationFeatureController@overridePlatformStatus')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/features/:feature_key/override',
    method: 'POST',
    transform: createTransform(null, 'data'),
}

// Route::post('organizations/{id}/features/{feature_key}/verify', 'OrganizationFeatureController@verifyFeature');
// SYSTEM ADMIN ONLY - duyệt/từ chối yêu cầu kích hoạt owner đã gửi qua request-verification ở trên
// (body: {status: 'verified'|'rejected', note}) - chỉ mở khoá can_enable, owner vẫn tự bật lại.
export const organization_verifyFeature_Api = {
    backend: `Route::post('organizations/:id/features/:feature_key/verify', 'OrganizationFeatureController@verifyFeature')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/features/:feature_key/verify',
    method: 'POST',
    transform: createTransform(null, 'data'),
}

// Route::get('organizations/get-typical-organizations', 'OrganizationController@getTypicalOrganizations');
export const organization_GetTypicalOrganizations_Api = {
    backend: `Route::get('organizations/get-typical-organizations', 'OrganizationController@getTypicalOrganizations')`,
    root: API_ROOT_URL,
    path: '/organizations/get-typical-organizations',
    method: 'GET',
    fieldTypes: organization_FieldTypes,
    transform: createListTransform(organizationSchema),
}

// Route::get('organizations/{id}/get-following-users', 'OrganizationController@getFollowingUsers');
export const organization_GetFollowingUsers_Api = {
    backend: `Route::get('organizations/{id}/get-following-users', 'OrganizationController@getFollowingUsers')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/get-following-users',
    method: 'GET',
    fieldTypes: organization_FieldTypes,
    transform: createListTransform(organizationSchema),
}

export const organization_getOrganizationsByAuth_Api = {
    backend: `Route::get('organizations/organization/get-items-by-auth', 'OrganizationController@getOrganizationsByAuth');`,
    root: API_ROOT_URL,
    path: '/organizations/organization/get-items-by-auth',
    method: 'GET',
    paramsFields: ['organization_id'],
    fieldTypes: organization_FieldTypes,
    transform: createListTransform(organizationSchema),
}

// Route::get('organizations/{id}/validate-sub-domain', 'OrganizationController@validateSubDomain');
export const organization_validateSubDomain_Api = {
    backend: `Route::get('organizations/{id}/validate-sub-domain', 'OrganizationController@validateSubDomain')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/validate-sub-domain',
    method: 'GET',
    transform: createTransform(organizationSchema, 'data'),
}

// Route::get('organizations/{id}/get', 'OrganizationController@getById');
export const organization_getById_Api = {
    backend: `Route::get('organizations/:id/get', 'OrganizationController@getById')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/get',
    method: 'GET',
    schema: organizationSchema,
    fieldTypes: organization_FieldTypes,
    transform: createTransform(organizationSchema, 'data'),
}
export const create_organization_getById_Api_action =
    () =>
        ({prefixStr = 'organization_getById_Api', query, values, maxAge =
            -1}) =>
            createAsyncAction({
                prefixStr: prefixStr + '@organization_getById_Api',
                query,
                values,
                apiInfo: organization_getById_Api,
                maxAge,
            })
// Route::get('organizations/{id}/show', 'OrganizationController@show');
export const organization_show_Api = {
    backend: `Route::get('organizations/{id}/show', 'OrganizationController@show')`,
    root: API_ROOT_URL,
    path: '/organizations/:id/show',
    method: 'GET',
    fieldTypes: organization_FieldTypes,
    transform: createTransform(organizationSchema, 'data'),
}

// Route::post('organizations/{id}/request-verify', 'OrganizationController@requestVerifyTaxCode');
export const organization_RequestVerify_Api = {
    backend: `Route::post('organizations/{id}/request-verify', 'OrganizationController@requestVerifyTaxCode');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/request-verify',
    method: 'POST',
    fields,
    fieldTypes: organization_FieldTypes,
    transform: createTransform(organizationSchema, 'data'),
}

export const organization_ExportPurchasePriceData_Api = {
    backend: `Route::post('exports/organization/{id}/export-purchasing-price-data', 'ProductPriceController@exportPurchasePriceData')`,
    root: API_ROOT_URL,
    path: '/exports/organization/:id/export-purchasing-price-data',
    method: 'POST',
    fields,
    fieldTypes: organization_FieldTypes,
}

export const organization_ExportPriceData_Api = {
    backend: `Route::post('exports/organization/{id}/export-price-data', 'ProductPriceController@exportPriceData')`,
    root: API_ROOT_URL,
    path: '/exports/organization/:id/export-price-data',
    method: 'POST',
    fields,
    fieldTypes: organization_FieldTypes,
}

export const organization_fetchLatestFeeds_Api = {
    backend: `Route::get('organizations/{id}/insights/get-latest-feeds', 'OrganizationInsightsController@fetchLatestFeeds'); // content_type: article,ask,post,repost,poll_question`,
    root: API_ROOT_URL,
    path: '/organizations/:id/insights/get-latest-feeds',
    method: 'GET',
    paramsFields: ['content_type'],
    schema: feedSchema,
    transform: createListTransform(feedSchema),
}

export const organization_getOrganizationsByUser_Api = {
    backend: `Route::get('organizations/user/{id}/gets', 'OrganizationController@getOrganizationsByUser');`,
    root: API_ROOT_URL,
    path: '/organizations/user/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'role'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

export const organization_fetchLatestFollowers_Api = {
    backend: `Route::get('organizations/{id}/insights/get-latest-followers', 'OrganizationInsightsController@fetchLatestFollowers');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/insights/get-latest-followers',
    method: 'GET',
    schema: followSchema,
    transform: createListTransform(followSchema),
}

export const organization_fetchLatestComments_Api = {
    backend: `Route::get('organizations/{id}/insights/get-latest-comments', 'OrganizationInsightsController@fetchLatestComments');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/insights/get-latest-comments',
    method: 'GET',
    schema: commentSchema,
    transform: createListTransform(commentSchema),
}

export const organization_fetchStatistics_Api = {
    backend: `Route::get('organizations/{id}/insights/get-statistics', 'OrganizationInsightsController@fetchStatistics');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/insights/get-statistics',
    method: 'GET',
    paramsFields: ['period'],
}

export const organization_getEventsByHost_Api = {
    backend: `Route::get('organization/{organization_id}/hosts/get-event-by-host', 'OrganizationHostsController@getEventsByHost');`,
    root: API_ROOT_URL,
    path: '/organization/:organization_id/hosts/get-event-by-host',
    method: 'GET',
    paramsFields: ['status', 'sort_by', 'keyword', 'organization_id'],
    schema: eventSchema,
    transform: createListTransform(eventSchema),
}

export const organization_getOrgMembersSiteMaps_Api = {
    backend: `API: Route::get('organization/{organization_id}/hosts/get-site-map', 'OrganizationHostsController@getOrgMembersSiteMaps');`,
    root: API_ROOT_URL,
    path: '/organization/:organization_id/hosts/get-site-map',
    method: 'GET',
}


export const organization_getOrganizationsByParishAssocRequest_Api = {
    backend: `Route::get('organizations/parish/association-request', 'OrganizationController@getOrganizationsByParishAssocRequest');`,
    root: API_ROOT_URL,
    path: '/organizations/parish/association-request',
    method: 'GET',
    paramsFields: ['keyword', 'status'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}
export const organization_getOrganizationsByDioceseAssocRequest_Api = {
    backend: `Route::get('organizations/diocese/association-request', 'OrganizationController@getOrganizationsByDioceseAssocRequest');`,
    root: API_ROOT_URL,
    path: '/organizations/diocese/association-request',
    method: 'GET',
    paramsFields: ['keyword', 'status'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}
export const organization_getOrganizationsByReligiousOrderAssocRequest_Api = {
    backend: `Route::get('organizations/religious-order/association-request', 'OrganizationController@getOrganizationsByReligiousOrderAssocRequest');`,
    root: API_ROOT_URL,
    path: '/organizations/religious-order/association-request',
    method: 'GET',
    paramsFields: ['keyword', 'status'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

// Route::post('organizations/{id}/change-assoc-status', 'OrganizationController@updateOrganizationsAssocStatus');
export const organization_updateOrganizationsAssocStatus_Api = {
    backend: `Route::post('organizations/{id}/change-assoc-status', 'OrganizationController@updateOrganizationsAssocStatus');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/change-assoc-status',
    method: 'POST',
    fields,
    fieldTypes: organization_FieldTypes,
    transform: createTransform(organizationSchema, 'data'),
}

export const user_fetchSuggestionOrganizationAppChoices_Api = {
    name: 'user_fetchSuggestionOrganizationAppChoices_Api',
    backend: `Route::get('recommendations/organization/suggested-items', 'PromoteController@getOrganizations');`,
    root: API_ROOT_URL,
    path: '/recommendations/organization/suggested-items',
    method: 'GET',
    paramsFields: ['category_id'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

export const organization_fetchItems_Api = {
    name: 'organization_fetchItems_Api',
    backend: `Route::get('organizations/fetch-items', 'OrganizationController@fetchItems');`,
    root: API_ROOT_URL,
    path: '/organizations/fetch-items',
    method: 'GET',
    paramsFields: ['keyword', 'country_id', 'org_type', 'parish_id', 'diocese_id', 'association_type', 'course_feature_active'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

export const organization_fetchGlobalOrganizations = {
    name: 'organization_fetchGlobalOrganizations',
    backend: `Route::get('organizations/fetch-global-items', 'OrganizationController@fetchGlobalOrganizations');`,
    root: API_ROOT_URL,
    path: '/organizations/fetch-global-items',
    method: 'GET',
    paramsFields: [],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

//=========  Group


export const organization_getGroups_Api = {
    name: 'organization_getGroups_Api',
    backend: `Route::get('organizations/{id}/get-groups', 'OrganizationGroupController@getGroups');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/get-groups',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'group_nbr', 'group_type'],
    schema: groupSchema,
    transform: createListTransform(groupSchema),
}

export const organization_getGroupTree_Api = {
    name: 'organization_getGroupTree_Api',
    backend: `Route::get('organizations/{id}/get-group-tree', 'OrganizationGroupController@getGroupTree');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/get-group-tree',
    method: 'GET',
}

export const organization_createGroup_Api = {
    name: 'organization_createGroup_Api',
    backend: `Route::post('organizations/{id}/create-group', 'OrganizationGroupController@createGroup');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/create-group',
    method: 'POST',
    schema: groupSchema,
    transform: createTransform(groupSchema, 'data'),
}

//=========  Feature Access Grants ("Cấp quyền tạm thời" - generic, xem
// Modules\Organization\Http\Controllers\FeatureAccessGrantController) - response KHÔNG qua
// normalizr (không phải entity chuẩn để normalize).

// Dùng bởi trang "/access-portal?org_id=...&feature_key=..." (ĐỘC LẬP khung Workspace) - user chỉ
// có grant (không phải admin) cũng gọi được, chỉ cần đăng nhập (xem checkAccess() backend).
export const organization_checkFeatureAccess_Api = {
    name: 'organization_checkFeatureAccess_Api',
    backend: `Route::get('organizations/{id}/feature-access-grants/check-access', 'FeatureAccessGrantController@checkAccess');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/feature-access-grants/check-access',
    method: 'GET',
    paramsFields: ['feature_key'],
}

export const organization_getFeatureAccessGrants_Api = {
    name: 'organization_getFeatureAccessGrants_Api',
    backend: `Route::get('organizations/{id}/feature-access-grants/gets', 'FeatureAccessGrantController@getList');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/feature-access-grants/gets',
    method: 'GET',
    paramsFields: ['feature_key', 'include_revoked'],
}

export const organization_grantFeatureAccess_Api = {
    name: 'organization_grantFeatureAccess_Api',
    backend: `Route::post('organizations/{id}/feature-access-grants/grant', 'FeatureAccessGrantController@grant');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/feature-access-grants/grant',
    method: 'POST',
}

export const organization_revokeFeatureAccessGrant_Api = {
    name: 'organization_revokeFeatureAccessGrant_Api',
    backend: `Route::post('organizations/{id}/feature-access-grants/{grant_id}/revoke', 'FeatureAccessGrantController@revoke');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/feature-access-grants/:grant_id/revoke',
    method: 'POST',
}

export const organization_deleteGroup_Api = {
    name: 'organization_deleteGroup_Api',
    backend: `Route::post('organizations/group/{id}/delete', 'OrganizationGroupController@deleteGroup');`,
    root: API_ROOT_URL,
    path: '/organizations/group/:id/delete',
    method: 'POST',
    schema: groupSchema,
    transform: createTransform(groupSchema, 'data'),
}

export const organization_updateGroup_Api = {
    name: 'organization_updateGroup_Api',
    backend: `Route::post('organizations/group/{id}/edit', 'OrganizationGroupController@updateGroup');`,
    root: API_ROOT_URL,
    path: '/organizations/group/:id/edit',
    method: 'POST',
    schema: groupSchema,
    transform: createTransform(groupSchema, 'data'),
}

export const organization_group_getById_Api = {
    backend: `Route::get('organizations/group/{id}/get', 'OrganizationGroupController@getGroupById');`,
    root: API_ROOT_URL,
    path: '/organizations/group/:id/get',
    method: 'GET',
    schema: groupSchema,
    transform: createTransform(groupSchema, 'data'),
}


export const organization_group_getGroupMembers_Api = {
    backend: `Route::get('organizations/group/{id}/get-members', 'OrganizationGroupController@getGroupMembers');`,
    root: API_ROOT_URL,
    path: '/organizations/group/:id/get-members',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status'],
    schema: groupMemberSchema,
    transform: createListTransform(groupMemberSchema),
}


export const organization_group_addMember_Api = {
    name: 'organization_group_addMember_Api',
    backend: `Route::post('organizations/group/{id}/add-member', 'OrganizationGroupController@addMember');`,
    root: API_ROOT_URL,
    path: '/organizations/group/:id/add-member',
    method: 'POST',
    schema: groupMemberSchema,
    transform: createTransform(groupMemberSchema, 'data'),
}

export const organization_group_editMember_Api = {
    name: 'organization_group_editMember_Api',
    backend: `Route::post('organizations/group-member/{id}/edit-member', 'OrganizationGroupController@editMember');`,
    root: API_ROOT_URL,
    path: '/organizations/group-member/:id/edit-member',
    method: 'POST',
    schema: groupMemberSchema,
    transform: createTransform(groupMemberSchema, 'data'),
}

export const organization_group_updateMemberInfo_Api = {
    name: 'organization_group_updateMemberInfo_Api',
    backend: `Route::post('organizations/group-member/{id}/update-member-info', 'OrganizationGroupController@updateMemberInfo');`,
    root: API_ROOT_URL,
    path: '/organizations/group-member/:id/update-member-info',
    method: 'POST',
    schema: groupMemberSchema,
    transform: createTransform(groupMemberSchema, 'data'),
}

export const organization_group_removeMember_Api = {
    name: 'organization_group_removeMember_Api',
    backend: `Route::post('organizations/group-member/{id}/remove-member', 'OrganizationGroupController@removeMember');`,
    root: API_ROOT_URL,
    path: '/organizations/group-member/:id/remove-member',
    method: 'POST',
    schema: groupMemberSchema,
    transform: createTransform(groupMemberSchema, 'data'),
}

export const organization_group_setMemberActive_Api = {
    name: 'organization_group_setMemberActive_Api',
    backend: `Route::post('organizations/group-member/{id}/set-active', 'OrganizationGroupController@setMemberActive');`,
    root: API_ROOT_URL,
    path: '/organizations/group-member/:id/set-active',
    method: 'POST',
    schema: groupMemberSchema,
    transform: createTransform(groupMemberSchema, 'data'),
}




export const platformStatisticSchema = new schema.Entity(
    'platform_statistics',
    {},
    {
        idAttribute: 'id',
    }
)

export const apps_getPlatformStatistics_Api = {
    name: 'apps_getPlatformStatistics_Api',
    backend: `Route::get('apps/get-platform-statistics', 'AppStatisticController@getPlatformStatistics');`,
    root: API_ROOT_URL,
    path: '/apps/get-platform-statistics',
    method: 'GET',
    schema: platformStatisticSchema,
    transform: createTransform(platformStatisticSchema, 'data'),
}


export const organization_fetchItemsBySysAdmin_Api = {
    name: 'organization_fetchItemsBySysAdmin_Api',
    backend: `Route::get('organizations/fetch-items-by-sysadmin', 'OrganizationController@fetchItemsBySysAdmin');`,
    root: API_ROOT_URL,
    path: '/organizations/fetch-items-by-sysadmin',
    method: 'GET',
    paramsFields: ['keyword', 'highlighted', 'org_type', 'privacy'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

export const organization_fetchLatestItemsBySysAdmin_Api = {
    name: 'organization_fetchLatestItemsBySysAdmin_Api',
    backend: `Route::get('organizations/fetch-latest-items-by-sysadmin', 'OrganizationController@fetchLatestItemsBySysAdmin');`,
    root: API_ROOT_URL,
    path: '/organizations/fetch-latest-items-by-sysadmin',
    method: 'GET',
    paramsFields: ['keyword', 'highlighted', 'org_type', 'privacy'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

export const organization_fetchWaitingItemsBySysAdmin_Api = {
    name: 'organization_fetchWaitingItemsBySysAdmin_Api',
    backend: `Route::get('organizations/fetch-waiting-items-by-sysadmin', 'OrganizationController@fetchWaitingItemsBySysAdmin');`,
    root: API_ROOT_URL,
    path: '/organizations/fetch-waiting-items-by-sysadmin',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: organizationSchema,
    transform: createListTransform(organizationSchema),
}

export const organization_getMemberPersonalProfile_Api = {
    name: 'organization_getMemberPersonalProfile_Api',
    backend: `Route::get('organizations/{id}/member/personal-profile', 'OrganizationController@getMemberPersonalProfile');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/member/personal-profile',
    method: 'GET',
    paramsFields: [],
}

export const organization_getMemberProfile_Api = {
    name: 'organization_getMemberProfile_Api',
    backend: `Route::get('organizations/{id}/members/{m_id}/profile', 'OrganizationController@getMemberProfile');`,
    root: API_ROOT_URL,
    path: '/organizations/:id/members/:m_id/profile',
    method: 'GET',
    paramsFields: [],
}